import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Keyboard, Navigation, Thumbs } from 'swiper';
import styled from 'styled-components';

import ArrowIcon from '@/assets/svg/detailed-car/arrow.svg';
import {
  BigSliderProps,
  DetailedCarGalleryImageItem,
} from '@/components/DetailedCarGallery/DetailedCarGallery.types';
import {
  Component,
  Slide,
  StyledNavButtonWrapper,
  StyledPicture,
} from '@/components/DetailedCarGallery/components/BigSlider/BigSlider';
import { colors } from '@/constants/theme';
SwiperCore.use([Navigation, Thumbs, Keyboard]);

function BigSliderModal({
  images,
  currentSlideIndex,
  thumbsSwiper,
  setCurrentSlideIndex,
  setModalSlideIndex,
}: BigSliderProps) {
  const prevNavButtonRef = useRef<HTMLDivElement>(null);
  const nextNavButtonRef = useRef<HTMLDivElement>(null);
  const [counterIndex, setCounterIndex] = useState(currentSlideIndex);

  const getCurrentSlideIndex = () => {
    if (counterIndex > images.length) {
      return 1;
    } else if (counterIndex === 0) {
      return images.length;
    } else {
      return counterIndex;
    }
  };

  return (
    <Component>
      <Swiper
        loop={true}
        allowTouchMove={images?.length > 1}
        initialSlide={currentSlideIndex - 1}
        thumbs={{ swiper: thumbsSwiper }}
        grabCursor={true}
        keyboard={{ enabled: true }}
        onSlideChange={(swiper) => {
          setCurrentSlideIndex(swiper.activeIndex);
          setCounterIndex(swiper.activeIndex);
          setModalSlideIndex?.(swiper.activeIndex);
        }}
        navigation={{
          prevEl: prevNavButtonRef.current,
          nextEl: nextNavButtonRef.current,
        }}
      >
        {images.map((item: DetailedCarGalleryImageItem, index) => (
          <SwiperSlide key={index}>
            <Slide>
              <StyledPicture
                desktop={{ src: item.desktop }}
                tabletLarge={{ src: item.desktop }}
                tabletSmall={{ src: item.desktop }}
                loading="lazy"
              />
            </Slide>
          </SwiperSlide>
        ))}
        {images.length > 1 ? (
          <>
            <StyledNavButtonWrapper ref={prevNavButtonRef} prev>
              <ArrowIcon />
            </StyledNavButtonWrapper>

            <StyledNavButtonWrapper ref={nextNavButtonRef} next>
              <ArrowIcon />
            </StyledNavButtonWrapper>
          </>
        ) : null}
      </Swiper>
      <SlideCounter>
        {getCurrentSlideIndex()} / {images.length}
      </SlideCounter>
    </Component>
  );
}

export default BigSliderModal;

const SlideCounter = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 3;
  display: inline-block;
  background-color: rgba(0, 0, 0, 0.65);
  color: ${colors.white};
  text-align: center;
  border-radius: 8px;
  font-weight: 500;
  font-size: 12px;
  line-height: 11px;
  padding: 5px;
  margin: 10px 20px;
`;
